import { ICountry } from 'core/classes/models/IReference'

export const mapPhoneCodeToCountryCode = (countries: ICountry[]): { [p: string]: string[] } => {
  const mapped: { [p: string]: string[] } = {}
  countries.forEach(({ phoneCode, value }) => {
    if (!mapped[phoneCode]) {
      mapped[phoneCode] = [value]
    } else {
      mapped[phoneCode].push(value)
    }
  })

  return mapped
}
